import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { assertDefined } from '../../../utils/assertDefined';
import { isCaptchaRequired } from '../isCaptchaRequired';

/**
 * Retrieves the current captcha token from the client state and sets it to null.
 */
export const consumeCaptchaToken = (
  client: DynamicClient
): string | undefined => {
  const core = getCore(client);

  const captchaToken = core.state.get().captchaToken;

  if (isCaptchaRequired(client)) {
    assertDefined(captchaToken, 'Captcha token is required');
  }

  core.state.set({
    captchaToken: null,
  });

  return captchaToken ?? undefined;
};
